//MUI Components
import { Box } from "@mui/material";

//My Components
import ProductosTab from "../../components/productosComponent";
import { Header } from "../../components/header";
import { Footer } from "../../components/footer";

function Productos() {
  return (
    <>
      <Header color={"#F0F0F0"} />
      <ProductosTab />

      <Box sx={{ marginTop: "3rem" }}>
        <Footer />
      </Box>
    </>
  );
}

export default Productos;
